import useBrands from '../../brand/queries/useBrands';

const useBrandQuery = ({ brandSlug }: { brandSlug?: string }) => {
    const { brands, loading } = useBrands({
        skip: !brandSlug,
    });
    const brand = brands.find(({ slug }) => slug === brandSlug);

    return {
        brand,
        loading,
    };
};

export default useBrandQuery;
